// extracted by mini-css-extract-plugin
module.exports = {"icon":"Overtime_icon__1NE46"};